import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useState } from "react";
import useCollapse from "react-collapsed";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../components/chip/chipCmp";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { TABLE_FILTER } from "../../config/cacheKey";
import { PaginationInfo } from "../../models/cartable.model";
import {
  Filter,
  GetLoansReportResponse,
  GetOnlineInstallmentReportRequest,
} from "../../models/report.model";
import {
  ExportLoansReport,
  GetLoansReport,
} from "../../services/report.service";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "customerFullName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "customerMobileNumber",
    label: "شماره همراه",
  },
  {
    id: "loanTemplateTitle",
    label: " طرح تسهیلات",
  },
  {
    id: "organizationTitle",
    label: "سازمان",
  },
  {
    id: "financialSupplierTitle",
    label: "تامین کننده مالی",
  },
  {
    id: "bankReferenceCode",
    label: " شناسه تسهیلات",
  },

  {
    id: "amount",
    label: "مبلغ تسهیلات (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },

  {
    id: "durationByMonth",
    label: "مدت تسهیلات",
  },
  {
    id: "stepSpaceByMonth",
    label: "فاصله اقساط",
  },
  {
    id: "customerFeeAmount",
    label: "کارمزد",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "creationDatePersian",
    label: "تاریخ درخواست متقاضی",
  },
  {
    id: "bankAssignDatePersian",
    label: "تاریخ اعطای تسهیلات",
  },
];
let muiSelected: any;

export default function LoansReport() {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  const [data, setData] = useState<GetLoansReportResponse[]>([]);
  const [valueCustomerNationalCode, setValueCustomerNationalCode] = useState<
    string
  >();
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  React.useEffect(() => {
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueCustomerNationalCode(filterData!.nationalCode!);
      }
    } else {
      filterData = null;
      queryClient.setQueryData(TABLE_FILTER, null);
      let filter = new Filter();
      filter.nationalCode = "";
      setValueFilterData(filter);
    }
    fillData(filterData!);
  }, []);
  const { mutateAsync: GetLoansReportMutate } = useMutation(GetLoansReport, {
    onSuccess: (data: ApiResultModel<GetLoansReportResponse[]>) => {
      setData(data.data!);
      setPageInfo(data.pageInfo);
    },
  });

  const { mutateAsync: ExportLoansReportMutate } = useMutation(
    ExportLoansReport,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.nationalCode = undefined;
    fillData(tabelFilter!);
  };

  const generateFilter = (
    filterData: Filter
  ): GetOnlineInstallmentReportRequest => {
    let request = new GetOnlineInstallmentReportRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetLoansReportMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };

  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }

  function deleteChip() {
    setValueCustomerNationalCode("");
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  const handelDetail = (referenceKey: string) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    window.sessionStorage.setItem("loanRequestId", "");
    window.sessionStorage.setItem("natinalCode", "");
    localStorage.setItem(
      "SUPPLIER_REQUEST_DATA",
      JSON.stringify({ referenceKey: referenceKey })
    );
    const newWindow = window.open(
      "/#/Search/SupplierSearch1/request-find-detail",
      "_blank"
    );
    newWindow?.history.pushState(
      {
        settlementData: { referenceKey: referenceKey },
      },
      "",
      "/Search/SupplierSearch1/request-find-detail"
    );
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    ExportLoansReportMutate(valueFilterData ? valueFilterData! : new Filter());
  };

  return (
    <div>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              queryClient.setQueryData(TABLE_FILTER, values);
              values.nationalCode = valueCustomerNationalCode;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                      type="number"
                      inputProps={{ maxLength: 10 }}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "30px" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueCustomerNationalCode ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "10px" }}
                      >
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() => handelDetail(row.referenceKey)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value =
                        row[column.id as keyof GetLoansReportResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id === "saleStatusTitle" ? (
                            <b style={{ color: "#FB8C00" }}> {value}</b>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <div className="row"></div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
